/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// This is to resolve iOS (and other touch interfaces) bugs with position fixed and input elements.
window.scrollEnabled = true;
$.fn.stop_scrolling = function(fixed_selector) {
  if (window.scrollEnabled) {
    window.scrollEnabled = false;
    var scroll_position = $('body').scrollTop();
    $(this).css({top:-scroll_position, overflow:'hidden', bottom:0, position:'absolute', left: 0, right: 0});
    $('body').scrollTop(0);
    return $(fixed_selector).css({position:'absolute'});
  }
};

$.fn.start_scrolling = function(fixed_selector) {
  if (!window.scrollEnabled) {
    window.scrollEnabled = true;
    var scroll_position = -parseInt($(this).css('top'), 10);
    $(this).css({overflow:'', top:'', bottom:'', position: '', left: 0, right: 0});
    $('body').scrollTop(scroll_position);
    return $(fixed_selector).css({position:'fixed'});
  }
};

$.fn.curtain = function(on_off, clickHandler) {
  if (clickHandler == null) { clickHandler = $.noop; }
  var curtain = $('#curtain');
  if (on_off === 'off') {
    curtain.addClass('in').remove();
    $('.scrollable').start_scrolling('.fixed');
    $('body').removeClass('behind-the-curtain');
    return $();
  } else if (on_off === 'on') {
    if (curtain.length === 0) {
      curtain = $('<div />', {id: 'curtain', "class":'in'}).appendTo('body');
    }
    curtain.css('zIndex', 5000);
    curtain.removeClass('in');
    $('.scrollable').stop_scrolling('.fixed');
    $('body').addClass('behind-the-curtain');
    curtain.off('touchend click').on('touchend click', clickHandler);
    return curtain;
  }
  return curtain;
};